Vue.component('country', {
    props: ['countries', 'i-country', 'i-region', 'required', 'creating'],

    data () {
        return {
            regions: [],

            country: '',

            region: '',

            countryRequired: false
        };
    },

    mounted () {
        this.country = this.iCountry;
        this.region = this.iRegion;

        if (this.required == undefined || this.required == true) {
            this.countryRequired = true;
        }
    },

    methods: {
        handleCountryChange(country) {
            if (country == null || country.length == 0) {
                return;
            }

            let selected = this.countries.filter(c => {
                return c.name === country;
            })[0];

            this.regions = selected.regions;
        }
    },

    watch: {
        iCountry () {
            this.country = this.iCountry;

            this.handleCountryChange(this.country);
        },

        iRegion () {
            this.region = this.iRegion;
        }
    },

    template: `
    <div :class="{'col-md-6': creating}">
        <div :class="{'row': creating}">
            <div :class="{'col-md-6': creating}">
                <div class="form-group">
                    <label for="country" v-if="!creating">Country</label>
                    
                    <select-field :taggable="false" placeholder="Country" name="country" :options="countries" :initial-value="country" @change="handleCountryChange" />
                </div>
            </div>
        
            <div :class="{'col-md-6': creating}">
                <div class="form-group">
                    <label for="country" v-if="!creating">Region</label>
                    
                    <select-field :taggable="false" placeholder="Region" name="region" :options="regions" :initial-value="region" />
                </div>
            </div>
        </div>
    </div>
        `
})
